/**
 * @Author: Zero
 * @Date: 2023-04-26 18:47:58
 * @Explain: 多选
 */
import { CheckboxItemType } from '@/definition/common/tdesign.d';
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { Checkbox } from 'tdesign-react';

type PropsType = {
  className?: string;
  /** 是否显示选框结构 */
  isShow?: boolean;
  /** Checkbox 选框渲染 */
  options: CheckboxItemType[];
  /** 布局方式 */
  layout?: 'column' | 'inline';
  /** 是否可用 */
  disabled?: boolean;
  /** 默认是否已经勾选 */
  defaultValue?: any;
  /** 是否已经勾选 */
  value?: any;
  /** onChange */
  onChange?: (value: any, context: any) => void;
};

const CheckboxGroup = (props: PropsType) => {
  const {
    className,
    isShow = true,
    options,
    layout = 'inline',
    disabled = false,
    defaultValue,
    value,
    onChange,
  } = props;

  return isShow ? (
    <Checkbox.Group
      className={classNames(
        'default-checkbox-group',
        {
          [`checkbox-group-${layout}`]: layout,
        },
        className,
      )}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onChange={onChange}
    >
      {options &&
        options.map((checkboxItem: any, radioIndex: number) => (
          <Checkbox
            key={radioIndex.toString()}
            disabled={checkboxItem.disabled}
            value={checkboxItem.value}
          >
            {checkboxItem?.labelKey
              ? intlGet(checkboxItem.labelKey)
              : checkboxItem.label}
          </Checkbox>
        ))}
    </Checkbox.Group>
  ) : (
    <div style={{ height: '31px' }} />
  );
};

export default CheckboxGroup;
